<h2 mat-dialog-title>{{ getDialogTitle() }}</h2>
<mat-dialog-content>
<form [formGroup]="form">
    <fieldset>
        <mat-form-field appearance="outline">
            <mat-label i18n>Guard type</mat-label>
            <mat-select formControlName="template">
                <mat-option *ngFor="let template of templates" [value]="template.type">
                    {{ template.name }}
                </mat-option>
            </mat-select>
            <mat-hint *ngIf="result">{{ result.description }}</mat-hint>
            <mat-hint *ngIf="!result" align="end" i18n>Select guard you want to add from the list above ^</mat-hint>
        </mat-form-field>
    </fieldset>
    <ng-container *ngIf="shouldShowOptions">
        <fieldset>
            <fui-fieldset-legend label="Guard options" i18n-label></fui-fieldset-legend>
            <p>
                <span *ngIf="!result.hasOptions" i18n>This guard does not require additional configuration.</span>
            </p>
            <ng-container *ngIf="result.hasOptions">
                <eas-workflow-form-field-filter-control [availableFields]="availableFormFields"
                                                        formControlName="options">
                </eas-workflow-form-field-filter-control>
            </ng-container>
        </fieldset>
    </ng-container>
</form>
</mat-dialog-content>
<mat-dialog-actions>
    <div>
        <button *ngIf="shouldShowDelete"
                mat-button
                color="warn"
                (click)="onDelete()"
                tabindex="-1"
                i18n>Delete guard</button>
    </div>
    <div>
        <button mat-button
                (click)="onCancel()"
                tabindex="-1"
                i18n>Discard</button>
        <button *ngIf="shouldShowSave"
                type="submit"
                mat-flat-button
                color="primary"
                (click)="onSave()"
                [disabled]="!form.valid">{{ getAddOrApply() }}</button>
    </div>
</mat-dialog-actions>
